import { useDispatch, useSelector } from 'react-redux';

import { modalOpen } from '../../../redux/dashboardActions';
import AdsInfoModal from './adsInfoModal';
import GeneralInfoModal, { GeneralInfoPair } from './generalInfoModal';

import { Ad, TableHeader } from './types';

import { Button, Modal } from '../../../../../component';
import { IconSmallerArrow } from '../../../../../component/icon/smaller-arrow';
import { useMemo, useState } from 'react';
import { updateBuildingData } from '../../redux/offersSecondary.actions';

const BuildingDetailsModalOffersSecondaryGeneral = (): JSX.Element => {
  const dispatch = useDispatch();

  const { statusModal } = useSelector((state: any) => state.dashboardState);
  const { buildingData, payloadRequest } = useSelector(
    (state: any) => state.offersSecondaryGeneralState
  );
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);

  const [isActive, setIsActive] = useState<string>('');

  const modalHead = (totalAds: string) => {
    return (
      <div className="offers-secondary-modal-head-container">
        <div className="offers-secondary-modal-head-info-container">
          <h1>{`${nls.modalOffersSecondary.header.title} (${totalAds})`}</h1>
        </div>
      </div>
    );
  };

  const generalInfoPair: GeneralInfoPair[] = [
    {
      label: nls.modalOffersSecondary.generalInfo.address,
      value: buildingData?.general_info?.address,
    },
    {
      label: nls.modalOffersSecondary.generalInfo.searchType,
      value: buildingData?.general_info?.search_type,
    },
    {
      label: nls.modalOffersSecondary.generalInfo.propertyType,
      value: buildingData?.general_info?.property_type,
    },
    {
      label: nls.modalOffersSecondary.generalInfo.propertyDimensionsM2,
      value: buildingData?.general_info?.property_dimensions_m2
        ? buildingData?.general_info?.property_dimensions_m2
        : '-',
    },
    {
      label: nls.modalOffersSecondary.generalInfo.meanPriceM2,
      value: buildingData?.general_info?.mean_price_m2
        ? buildingData?.general_info?.mean_price_m2
        : '-',
    },
    {
      label: nls.modalOffersSecondary.generalInfo.propertyAge,
      value: buildingData?.general_info?.property_age || '-',
    },
  ];

  const addingOrdenation = (
    text: string,
    oderAction: () => void
  ): JSX.Element => {
    return (
      <div className="offers-secondary-ads-column-title">
        <span>{text}</span>
        <Button
          className={`btn offers-secondary-ads-column-order-button ${
            isActive === text ? 'active' : ''
          }`}
          onClick={() => {
            setIsActive(isActive === text ? '' : text);
            oderAction();
          }}
          cy={`${text.toUpperCase()}ButtonOrder`}
        >
          <IconSmallerArrow cy={`${text.toUpperCase()}Filter`} />
        </Button>
      </div>
    );
  };

  const orderActionBuider = (label: string, key: string) => {
    return () => {
      const isAsc = isActive === label;
      const sortedAds = [...buildingData?.ads].sort((a, b) => {
        const numberA =
          typeof a[key] === 'string'
            ? Number(a[key].replace(/[^\d,]/g, '').replace(',', '.'))
            : a[key];
        const numberB =
          typeof b[key] === 'string'
            ? Number(b[key].replace(/[^\d,]/g, '').replace(',', '.'))
            : b[key];
        const keyA = isNaN(numberA) ? 0 : numberA;
        const keyB = isNaN(numberB) ? 0 : numberB;
        return isAsc ? keyB - keyA : keyA - keyB;
      });
      const newBuildingData = { ...buildingData, ads: sortedAds };
      dispatch(updateBuildingData(newBuildingData));
    };
  };

  const tableHeader: TableHeader[] = [
    {
      text: nls.modalOffersSecondary.adsInfo.address,
      column: 'address',
      className: 'left',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.value,
        orderActionBuider(nls.modalOffersSecondary.adsInfo.value, 'price')
      ),
      column: 'value',
      className: 'left',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.valuePerArea,
        orderActionBuider(
          nls.modalOffersSecondary.adsInfo.valuePerArea,
          'price_m2'
        )
      ),
      column: 'value_per_area',
      className: 'left',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.area,
        orderActionBuider(nls.modalOffersSecondary.adsInfo.area, 'area')
      ),
      column: 'area',
      className: 'text-center justify-center',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.dormitory,
        orderActionBuider(
          nls.modalOffersSecondary.adsInfo.dormitory,
          'dormitory'
        )
      ),
      column: 'dormitory',
      className: 'text-center justify-center',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.suites,
        orderActionBuider(nls.modalOffersSecondary.adsInfo.suites, 'suites')
      ),
      column: 'suites',
      className: 'text-center justify-center',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.garages,
        orderActionBuider(nls.modalOffersSecondary.adsInfo.garages, 'garages')
      ),
      column: 'garages',
      className: 'text-center justify-center',
    },
    {
      text: addingOrdenation(
        nls.modalOffersSecondary.adsInfo.adAge,
        orderActionBuider(nls.modalOffersSecondary.adsInfo.adAge, 'ad_duration')
      ),
      column: 'ad_age',
      className: 'text-center justify-center',
    },
    {
      text: '',
      column: 'link',
      className: 'text-center',
    },
  ];

  const tableInfo: Ad[] = useMemo(() => buildingData?.ads, [buildingData?.ads]);

  return (
    <>
      {statusModal === `open building secondary-general` && (
        <Modal
          cy="BuildingDetails"
          title={modalHead(buildingData?.general_info?.total_ads)}
          open={statusModal === `open building secondary-general`}
          close={() => dispatch(modalOpen(''))}
          size="large-full-height"
        >
          <GeneralInfoModal data={generalInfoPair} />
          <AdsInfoModal tableHeader={tableHeader} tableInfo={tableInfo} />
        </Modal>
      )}
    </>
  );
};

export default BuildingDetailsModalOffersSecondaryGeneral;
